import React from "react";
import { cn } from "../ui";

/**
 * AuthStepProgress — the progress strip on the multi-step auth flows: the
 * three-step password reset and the three-step institute registration.
 *
 * `aria-hidden` because the current step is already announced by the heading
 * above it, which changes with the step. A screen reader that also read this
 * would hear the position twice and the strip has no other information in it.
 *
 * It lives in `Auth/`, not in `ui/`: it is decoration for one family of screens
 * with no behaviour of its own, and a primitive that only ever means "which of
 * the login flow's steps am I on" is not a primitive.
 *
 * Props:
 *   total   — number of steps
 *   current — 1-based index of the step being shown
 */
const AuthStepProgress = ({ total, current, className = "" }) => (
  <div
    aria-hidden="true"
    className={cn("tw-flex tw-items-center tw-justify-center tw-gap-2", className)}
  >
    {Array.from({ length: total }, (_, i) => i + 1).map((step) => (
      <span
        key={step}
        className={cn(
          "tw-h-1.5 tw-rounded-sm tw-transition-all tw-duration-300",
          step === current ? "tw-w-8 tw-bg-primary" : "tw-w-4",
          step < current && "tw-bg-primary/40",
          step > current && "tw-bg-line"
        )}
      />
    ))}
  </div>
);

export default AuthStepProgress;
